import { differenceInMilliseconds, isValid } from 'date-fns';

interface Props {
  startDateTime: Date | string;
  endDateTime: Date | string;
}

/**
 * Determines if two dates are valid and different.
 * @returns boolean
 */
export const hasDateTimeWindow = ({
  startDateTime,
  endDateTime,
}: Props): boolean => {
  const startDateTimeDate = new Date(startDateTime);
  const endDateTimeDate = new Date(endDateTime);

  if (!isValid(startDateTimeDate) || !isValid(endDateTimeDate)) {
    return false;
  }

  return Boolean(differenceInMilliseconds(endDateTimeDate, startDateTimeDate));
};
